export default __webpack_public_path__ + "static/media/jibon-desktop-two.0ddfc7bd.png";